import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';

import { FilterSelectionState, FiltersOptions, ModelsExperienceFilterChangeConfig, ModelsExperienceFilters } from '../models';

@Component({
	selector: 'mb-highlighted-filters',
	templateUrl: './highlighted-filters.component.html',
	styleUrls: ['./highlighted-filters.component.scss']
})
export class HighlightedFiltersComponent implements OnChanges {

	@InjectConfig(ModelsExperienceConfigKey.HIGHLIGHTED_FILTERS) public readonly configFilters: { [text: string]: string } = {};
	@Input() public highlightedFilters: ModelsExperienceFilters[];
	@Input() public urlFilters: ModelsExperienceFilters[];
	@Output() public onSelectFilters: EventEmitter<ModelsExperienceFilterChangeConfig> = new EventEmitter<ModelsExperienceFilterChangeConfig>();

	public selectedFilter: ModelsExperienceFilters;
	public iconsList: FiltersOptions[] = [];

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes?.urlFilters?.currentValue?.length) {
			this.selectedFilter = this.urlFilters[0];
			this.generateOptions();
		} else {
			this.selectedFilter = null;
		}
	}

	public getSelectedFilters(event): void {
		this.selectedFilter = event['checked'] ? event['filter'] : null;

		const selectedFilterConfig: FilterSelectionState = {
			id: event['filter'].meFilterId,
			checked: event['checked']
		};
		this.onSelectFilters.emit({ selectedHighlightedFilter: this.selectedFilter, selectedFilterConfig });
	}

	private generateOptions(): void {
		if (this.selectedFilter) {
			this.selectedFilter.options = this.highlightedFilters.find((filterData) => this.selectedFilter.meFilterId === filterData.meFilterId)?.options;
		}
	}
}
